import { createZustandStore } from '@udecode/plate-common';

export type FloatingLinkType = 'url' | 'article' | 'anchor';
export type FloatingLinkMode = '' | 'insert' | 'edit';

// This is a copy of the original floatingLinkStore.ts
// but with additions to support interlinks and element linking.
// Named differently from the original to avoid name collision
export const floatingLinksStore = createZustandStore('floatingLinks')({
  /** Editor id that the link is floating on */
  openEditorId: null as null | string,

  /** What type link is this? Url, Article or Element */
  linkType: 'url' as FloatingLinkType,

  /** Article Id for interlinks */
  interlinkId: '',

  /** Title of the article linked to */
  interlinkTitle: '',

  /** LangId of the article linked to */
  interlinkLangId: '',

  /** Id of the element linked to */
  linkedElementId: '',

  /** Url that a 'url' style link links to */
  url: '',

  /** Text that appears in the article */
  text: '',

  /**
   * Should the link open in a new tab, this ends up setting the `target`
   * property
   */
  newTab: false,

  /** "insert" for a new link, "edit" for an existing link */
  mode: '' as FloatingLinkMode,

  /** For an existing link, are we editing or viewing the details */
  isEditing: false,
})
  .extendActions((set) => ({
    reset: () => {
      set.linkType('url');
      set.interlinkId('');
      set.interlinkTitle('');
      set.text('');
      set.url('');
      set.newTab(false);
      set.mode('');
      set.isEditing(false);
      set.openEditorId(null);
      set.interlinkLangId('');
    },
  }))
  .extendActions((set) => ({
    show: (mode: FloatingLinkMode, editorId: string) => {
      set.mode(mode);
      set.isEditing(false);
      set.openEditorId(editorId);
    },
    hide: () => {
      set.reset();
    },
  }))
  .extendSelectors((state) => ({
    isOpen: (editorId: string) => state.openEditorId === editorId,
  }));

export const floatingLinkActions = floatingLinksStore.set;
export const floatingLinkSelectors = floatingLinksStore.get;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useFloatingLinkSelectors = () => floatingLinksStore.use;
